import { render } from "./Typing.vue?vue&type=template&id=25c55990&scoped=true"
import script from "./Typing.vue?vue&type=script&lang=js"
export * from "./Typing.vue?vue&type=script&lang=js"

import "./Typing.vue?vue&type=style&index=0&id=25c55990&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c55990"]])

export default __exports__